import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env } from "@/env.js";

let _client: SupabaseClient | null = null;

export function supabase(): SupabaseClient {
  if (_client) return _client;
  _client = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
    auth: {
      persistSession: false,        // CRITICAL: no localStorage/cookies — XSS-resistant
      autoRefreshToken: false,
      detectSessionInUrl: false,    // we parse the hash manually in /auth/callback
      storage: undefined,
    },
    realtime: {
      params: { eventsPerSecond: 5 },
    },
  });
  return _client;
}
